import React from 'react';
import { Col, Row } from 'react-bootstrap';


const Profile = props => {
  return (<>
    <Col xs={12} xl={4}>
      <Row>
        <Col xs={12}>

        </Col>
        <Col xs={12}>

        </Col>
      </Row>
    </Col>
  </>);
}

export default Profile;